import { defineStore } from 'pinia';
import type { NavigationState } from '~~/types/vuex/Navigation';

export const navigationStore = defineStore('navigation', {
  state: () => ({
    isNavigationOpen: false,
    currentFirstLevelCategorySlug: '',
  }),
  actions: {
    toggleNavigation(payload: boolean) {

      this.isNavigationOpen = payload; 

    },
    setCurrentFirstLevelCategorySlug(payload: string) {

      this.currentFirstLevelCategorySlug = payload; 

    },
  },
});
